/**
 * MeetingsTab — shared tab showing scheduled meetings.
 * Used in StudentDashboard and TutorDashboard.
 *
 * Props:
 *   meetings - array of meeting objects
 */
import React from 'react';
import { Calendar } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';

const MeetingsTab = ({ meetings = [] }) => (
    <Card>
        <CardHeader>
            <CardTitle>Scheduled Meetings</CardTitle>
        </CardHeader>
        <CardContent>
            {meetings.length === 0 ? (
                <div className="text-center py-12">
                    <Calendar className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-600">No meetings scheduled</p>
                </div>
            ) : (
                <div className="space-y-4">
                    {meetings.map((meeting) => (
                        <div key={meeting.id} className="border rounded-lg p-4">
                            <div className="flex justify-between items-start">
                                <div>
                                    <p className="font-semibold">Meeting with Tutor</p>
                                    <p className="text-sm text-gray-600">
                                        {new Date(meeting.meeting_date).toLocaleString()}
                                    </p>
                                    <p className="text-xs text-gray-500 mt-1">
                                        Duration: {meeting.duration_minutes} minutes
                                    </p>
                                </div>
                                <Badge variant={meeting.status === 'scheduled' ? 'default' : 'secondary'}>
                                    {meeting.status}
                                </Badge>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </CardContent>
    </Card>
);

export default MeetingsTab;
